var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":"bar","height":_vm.height,"options":_vm.chartOptions,"series":_vm.seriesInfo.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }